export default "__VITE_ASSET__CedlGxvK__"